import React from 'react';
import { connect } from 'react-redux';
import Select from 'react-select'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import TodosForm from './TodosForm';
import { sortOpts } from '../../utils/utils'
import { fetchTodolists, editTodolist } from "../../actions/todolistActions";
import { fetchTodos, editTodo } from "../../actions/todoActions";

class TodolistsForm extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      data: {
        todolist_desc: '',
        todolist_id: 0,
        todolist_active: 1,
        todolist_order_id: props.order.order_id,
        todolist_dline: props.order.order_edate || moment().format('Y-MM-DD')
      },
      adding: false,
      errors: {}
    }
  }

  createTodolist = e => {
    if (!this.state.data.todolist_desc) return;
    const { data } = this.state;
    this.props.editTodolist({
      ...data,
      todolist_id: 0
    }, errors => {
      if (errors) {
        this.setState({errors});
        return;
      }
      this.setState({
        data: {
          ...data,
          todolist_desc: ''
        },
        errors: {},
        adding: false
      });
    });
  }

  duplicateTodolist = e => {
    if (!this.state.data.todolist_id) return;
    const { data } = this.state;
    this.props.editTodolist({
      ...data,
      duplicate: 1
    }, errors => {
      if (errors) {
        this.setState({errors});
        return;
      }
      this.props.fetchTodolists({order_id: this.props.order.order_id});
      this.props.fetchTodos({order_id: this.props.order.order_id});
      this.setState({
        errors: {},
        adding: false
      });
    });
  }

  updateSelect = e => {
    this.setState({
      data: {
        ...this.state.data,
        todolist_id: e.value
      }
    });
  }

  updateInput = e => {
    this.setState({
      data: {
        ...this.state.data,
        todolist_desc: e.target.value
      }
    });
  }

  updateDate = e => {
    this.setState({
      data: {
        ...this.state.data,
        todolist_dline: e.format('Y-MM-DD')
      }
    });
  }

  startAdding = () => {
    this.setState({adding: true});
  }

  cancelAdding = () => {
    this.setState({adding: false});
  }

  renderTodolistSelect() {
    const {
      todolistsDefault,
      order: {
        order_id: orderId
      }
    } = this.props;
    const { data } = this.state;
    const filteredTodolists = todolistsDefault.filter(el => el.todolist_active);
    const options = filteredTodolists.map(el => {
      return {
        label: el.todolist_desc,
        value: el.todolist_id
      };
    });
    options.sort(sortOpts);
    return (
      <div className="form-group">
        <div className="row form-horizontal form-group">
          <div className="col-sm-2">
            <button
              onClick={this.cancelAdding}
              className="btn btn-default"
              title="Отменить"
            >
              Отменить
            </button>
          </div>
          {orderId !== 0 && (
            <div>
              <div className="col-sm-3">
                <Select
                  clearable={false}
                  options={options}
                  value={data.todolist_id}
                  onChange={this.updateSelect}
                  placeholder="Добавить чек-лист"
                  title="Добавить чек-лист"
                />
              </div>
              <div className="col-sm-1">
                <button
                  onClick={this.duplicateTodolist}
                  className="btn btn-success"
                  title="Добавить"
                >
                  <span className="glyphicon glyphicon-save"></span>
                </button>
              </div>
              <label className="control-label col-sm-2 text-right">
                Срок выполнения до
              </label>
              <div className="col-sm-3">
                <DatePicker
                  className="form-control"
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  selected={moment(data.todolist_dline)}
                  onChange={this.updateDate}
                />
              </div>
            </div>
          )}
        </div>
        <div className="row form-horizontal form-group">
          <label className="control-label col-sm-3 text-right">
            Создать пустой
          </label>
          <div className="col-sm-2">
            <input
              type="text"
              value={data.todolist_desc}
              onChange={this.updateInput}
              className="form-control"
              placeholder="Название"
              title="Название пустого чек-листа"
            />
          </div>
          <div className="col-sm-1">
            <button
              onClick={this.createTodolist}
              className="btn btn-success"
              title="Добавить"
            >
              <span className="glyphicon glyphicon-save"></span>
            </button>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const {
      todolists,
      todos,
      users,
      editTodo,
      editTodolist,
      order: {
        order_id: orderId,
        order_empl2: userId
      }
    } = this.props;
    const { errors, adding } = this.state;
    const todosObject = {};
    for (let index = 0; index < todos.length; index++) {
      if (todosObject[todos[index].todo_todolist_id]) {
        todosObject[todos[index].todo_todolist_id].push(todos[index]);
      }
      else {
        todosObject[todos[index].todo_todolist_id] = [todos[index]];
      }
    }
    const filteredTodolists = todolists.filter(el => el.todolist_active);
    return (
      <div className="todolists-container">
        {errors.form && <div className="alert alert-danger">{errors.form}</div>}
        {adding ? this.renderTodolistSelect() : (
          <div className="row form-horizontal form-group">
            <div className="col-sm-1">
              <button
                onClick={this.startAdding}
                className="btn btn-primary"
                title="Добавить"
              >
                Добавить
              </button>
            </div>
          </div>
        )}
        <div className="todolists-list">
          {filteredTodolists.map(el => {
            return (
              <TodosForm
                key={el.todolist_id}
                todolist={el}
                todos={todosObject[el.todolist_id] || []}
                editTodo={editTodo}
                editTodolist={editTodolist}
                orderId={orderId}
                userId={userId}
                users={users}
              />
            );
          })}
        </div>
      </div>
    );
  }
}

function mapStoreToProps(store) {
  return {
    todolists: store.todolists,
    todolistsDefault: store.todolistsDefault,
    todos: store.todos,
    users: store.empls
  }
}

export default connect(mapStoreToProps, {
  fetchTodolists,
  fetchTodos,
  editTodo,
  editTodolist
})(TodolistsForm);



// WEBPACK FOOTER //
// ./src/components/todo/TodolistsForm.js